const noTransitionInit = () => {
  document.body.classList.remove('preload');
};

export default noTransitionInit;
